import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  LucideAngularModule,
  PhoneIcon,
  MessageCircleIcon,
  ZapIcon,
} from 'lucide-angular';
import { UserMenuComponent } from '../../auth/user-menu/user-menu';
import { StoreService } from '../../../services/store.service';
import { Sucursal } from '../../../types/stores';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'allas-top-bar',

  imports: [CommonModule, LucideAngularModule, UserMenuComponent],
  templateUrl: 'top-bar.html',
})
export class TopBarComponent {
  private storeService = inject(StoreService);
  readonly phoneIcon = PhoneIcon;
  readonly messageCircleIcon = MessageCircleIcon;
  readonly zapIcon = ZapIcon;

  readonly selectedStore = toSignal(this.storeService.selectedStore$, {
    initialValue: null,
  });
}
